import { DropdownMenuItem } from "./DropdownMenu";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import usePermissions from "../../../hooks/usePermissions";

const DropdownMenuItemDeletion = ({ onDeleteHandler }) => {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const hasDeletePermissions = permissions.canDelete();

  return (
    hasDeletePermissions && (
      <DropdownMenuItem
        className="hover:cursor-pointer flex flex-row items-center gap-x-2"
        onClick={onDeleteHandler}
      >
        <Trash2 className="h-4 w-4" />
        {t("defaults.deleteLabel")}
      </DropdownMenuItem>
    )
  );
};

export default DropdownMenuItemDeletion;
